import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { WordTemplate, PlaceholderInfo } from '../beans/word-template';

@Injectable()
export class WordTemplateService {

	private baseUrl = environment.serviceBaseUrl + '/word-template';

	constructor(private http: HttpClient) { }

	private headers(): HttpHeaders {
		return new HttpHeaders().set('Cache-Control', 'no-cache');
	}

	findAll(): Observable<WordTemplate[]> {
		return this.http.get<WordTemplate[]>(this.baseUrl + '/', { headers: this.headers() });
	}

	findByType(type: string): Observable<WordTemplate[]> {
		return this.http.get<WordTemplate[]>(this.baseUrl + '/by-type?type=' + type, { headers: this.headers() });
	}

	getPlaceholders(type?: string): Observable<any> {
		let url = this.baseUrl + '/placeholders';
		if (type) {
			url += '?type=' + type;
		}
		return this.http.get<any>(url, { headers: this.headers() });
	}

	uploadDocx(file: File): Observable<WordTemplate> {
		const formData = new FormData();
		formData.append('file', file);
		return this.http.post<WordTemplate>(this.baseUrl + '/upload', formData, {
			headers: new HttpHeaders().set('Cache-Control', 'no-cache')
		});
	}

	uploadZip(file: File): Observable<WordTemplate[]> {
		const formData = new FormData();
		formData.append('file', file);
		return this.http.post<WordTemplate[]>(this.baseUrl + '/upload-zip', formData, {
			headers: new HttpHeaders().set('Cache-Control', 'no-cache')
		});
	}

	rename(id: number, name: string): Observable<WordTemplate> {
		return this.http.post<WordTemplate>(this.baseUrl + '/' + id + '/rename?name=' + encodeURIComponent(name), {}, {
			headers: this.headers()
		});
	}

	delete(id: number): Observable<any> {
		return this.http.delete(this.baseUrl + '/' + id, { headers: this.headers() });
	}

	checkName(name: string): Observable<any> {
		return this.http.get(this.baseUrl + '/check-name?name=' + encodeURIComponent(name), { headers: this.headers() });
	}

	getHtml(id: number): Observable<any> {
		return this.http.get(this.baseUrl + '/' + id + '/html', { headers: this.headers() });
	}

	saveHtml(id: number, html: string): Observable<WordTemplate> {
		const formData = new FormData();
		formData.append('html', html);
		return this.http.post<WordTemplate>(this.baseUrl + '/' + id + '/save-html', formData, {
			headers: new HttpHeaders().set('Cache-Control', 'no-cache')
		});
	}

	downloadTemplate(id: number): Observable<HttpResponse<Blob>> {
		return this.http.get(this.baseUrl + '/' + id + '/download', {
			observe: 'response',
			responseType: 'blob'
		});
	}

	downloadAllZip(): Observable<HttpResponse<Blob>> {
		return this.http.get(this.baseUrl + '/download-all-zip', {
			observe: 'response',
			responseType: 'blob'
		});
	}

	deleteAll(): Observable<any> {
		return this.http.delete(this.baseUrl + '/delete-all', { headers: this.headers() });
	}

	generateDocument(templateId: number, lawsuiteId: number, instanceId?: number): Observable<HttpResponse<Blob>> {
		let url = this.baseUrl + '/' + templateId + '/generate?lawsuiteId=' + lawsuiteId;
		if (instanceId) {
			url += '&instanceId=' + instanceId;
		}
		return this.http.post(url, {}, {
			observe: 'response',
			responseType: 'blob'
		});
	}
}
